<template>
  <base-form :can-back="isEnableBack">
    <slot />
    <template #submit-button v-if="canEdit">
      <edit-button class="px-5" />
    </template>
    <template #expansion-buttons-right>
      <slot name="expansion-buttons-right" />
    </template>
  </base-form>
</template>

<script>
import BaseForm from '@/views/templates/forms/BaseForm'
import EditButton from '@/views/molecules/buttons/EditButton'

export default {
  name: "ViewerForm",
  components: {
    BaseForm,
    EditButton,
  },
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
    canBack: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isEnableBack() {
      return this.canBack && !this.$store.state.account.is_guest;
    },
  },
}
</script>
